import { render, staticRenderFns } from "./TableComandos.vue?vue&type=template&id=792eace4"
import script from "./TableComandos.vue?vue&type=script&lang=js"
export * from "./TableComandos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports